export default {
  choose: {
    title: 'Usuń {{name}} z roli właściciela',
    title_no_owner: 'Wybierz właściciela dla {{restaurant}}',
    description: 'Wybierz, kto przejmie rolę po {{name}}, lub na razie zostaw {{restaurant}} bez właściciela.',
    description_no_owner: '{{restaurant}} nie ma właściciela. Wybierz kogoś z zespołu lub nową osobę.',
    new_owner: 'Nowy właściciel',
    previous_owner: '{{name}} po zmianie',
  },
  options: {
    team: {
      title: 'Ktoś z zespołu',
      loading: 'Ładowanie zespołu…',
      description_one: 'Dowolny operator lub pracownik, {{count}} osoba.',
      description_few: 'Dowolny operator lub pracownik, {{count}} osoby.',
      description_many: 'Dowolny operator lub pracownik, {{count}} osób.',
      description_other: 'Dowolny operator lub pracownik, {{count}} osoby.',
      empty: 'W zespole nie ma jeszcze nikogo innego.',
      search: 'Szukaj w zespole po imieniu lub e-mailu',
      no_match: 'Nikt w zespole nie pasuje do „{{query}}”.',
    },
    new: {
      title: 'Nowa osoba',
      description: 'Od razu zostaje właścicielem, a dane logowania dostaje e-mailem.',
    },
    none: {
      title: 'Na razie bez właściciela',
      description: 'Wybierz właściciela później. Do tego czasu {{restaurant}} nie ma właściciela.',
    },
    keep: {
      title: 'Zostaje w zespole jako operator',
      description: 'Zachowuje dostęp do restauracji, którymi zarządza obecnie.',
    },
    remove: {
      title: 'Usunięty z zespołu',
      description: 'Natychmiast traci dostęp do panelu.',
    },
  },
  roles: {
    operator: 'Operator',
    employee: 'Pracownik',
  },
  fields: {
    first_name: 'Imię',
    last_name: 'Nazwisko',
    email: 'E-mail',
  },
  email_errors: {
    invalid_email: 'Wpisz prawidłowy e-mail, np. imie@example.com.',
    email_is_owner: '{{name}} jest już właścicielem.',
    email_is_manager: '{{name}} jest już w zespole.',
    email_taken: 'Ktoś spoza tego zespołu loguje się już tym adresem e-mail. Użyj innego adresu.',
  },
  confirm: {
    title: 'Usunąć {{name}} z roli właściciela?',
    title_no_owner: 'Ustanowić {{name}} właścicielem?',
    description_both: 'Obie zmiany następują razem. Jeśli jedna się nie powiedzie, nic się nie zmieni.',
    description: 'Sprawdź zmianę przed potwierdzeniem.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> nie ma właściciela, dopóki go nie wybierzesz. Wszystko, co wymaga właściciela, czeka do tego czasu.',
    new: '<b>{{name}}</b> od razu zostaje właścicielem {{restaurant}}.',
    email:
      'Dane logowania trafią na adres <b>{{email}}</b>. Sprawdź go: każdy, kto ma ten adres, może zalogować się jako właściciel.',
    team: '<b>{{name}}</b> zostaje właścicielem {{restaurant}}.',
    group_access:
      'Jako właściciel dostanie dostęp do wszystkich restauracji grupy {{group}}, czyli potencjalnie do większej liczby niż obecnie.',
    keep: '<b>{{name}}</b> zostaje w zespole jako operator.',
    remove: '<b>{{name}}</b> zostaje usunięty z zespołu i nie może się już logować.',
  },
  error: {
    title: 'Nie udało się zmienić właściciela.',
    description:
      'Nic nie zostało zmienione. Spróbuj ponownie lub skontaktuj się z pomocą techniczną, jeśli problem się powtarza.',
  },
  buttons: {
    continue: 'Dalej',
    cancel: 'Anuluj',
    back: 'Wstecz',
    remove_as_owner: 'Usuń z roli właściciela',
    make_owner: 'Ustanów właścicielem',
    saving: 'Zapisywanie…',
    try_again: 'Spróbuj ponownie',
    choose_instead: 'Wybierz zamiast tego: {{name}}',
    invite_instead: 'Zaproś zamiast tego nową osobę',
  },
};
